
import { mixins, Options } from 'vue-class-component';
import CartWidgetMixin from '@/mixins/cartWidget';
import LazyImage from '../LazyImage.vue';

@Options({
  components: {
    LazyImage
  }
})
export default class MDiscountEligible extends mixins(CartWidgetMixin) {
  get starCheckmark() {
    if (this.customStarImage) {
      return this.customStarImage;
    } else {
      return require('@/assets/images/star-checkmark.svg');
    }
  }

  get discountEligibleTitle() {
    if (this.nftEligibleTitle) {
      return this.nftEligibleTitle;
    } else {
      return 'NFT Discount Eligible';
    }
  }

  get discountEligibleMessage() {
    if (this.nftEligibleMessage) {
      return this.nftEligibleMessage;
    } else {
      return 'Use "Connect Wallet" button to apply discounts';
    }
  }
}
